import { API_BASE_URL } from "../assets/const";
import {createNotification} from "../components/Notifications/Notifications";
import { minToTime } from "../utils/MinToTime";
import { timeToMin } from "../utils/timeToMin";
import {checkAndUpdateToken} from "./auth";
import {buildDefaultHeaders} from "./helper";
import {
    GET_TIME_SLOT_LIST, 
    SET_TIME_SLOT_LIST_LOADING,
    SET_TIME_SLOT_BY_ID
} from "./types";

export const getTimeSlotList = (params) => async(dispatch, getState) => {
    dispatch({type: SET_TIME_SLOT_LIST_LOADING, payload: true});
    await dispatch(checkAndUpdateToken());
    const urlParams = new URLSearchParams({...params}).toString();
    if (getState().auth.token) {
        const response = await fetch(`${API_BASE_URL}/timeslot?${urlParams}`, {
            method: "GET",
            ...buildDefaultHeaders(getState)
        });

        const result = (await response.json());

        if (response.ok) {
            dispatch({type: GET_TIME_SLOT_LIST, payload: result});
        } else {
            dispatch({type: GET_TIME_SLOT_LIST, payload: []});
            createNotification('error', result.error)
        }
    }
    dispatch({type: SET_TIME_SLOT_LIST_LOADING, payload: false});
};

export const updateTimeSlot = (data, params) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {

        const newData = {
            ...data,
            starttime: timeToMin(data.starttime),
            stoptime: timeToMin(data.stoptime)
        }

        const response = await fetch(`${API_BASE_URL}/timeslot/${data.id}`, {
            method: "PUT",
            body: JSON.stringify(newData),
            ...buildDefaultHeaders(getState)
        });
        if (response.ok) {
            await dispatch(getTimeSlotList(params));
            createNotification('success', 'Успешно!');
        }
    };
}

export const createTimeSlot = (data, addMode, params) => async(dispatch, getState) => {

    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {

        const newData = {
            ...data,
            starttime: timeToMin(data.starttime),
            stoptime: timeToMin(data.stoptime)
        }
        const response = await fetch(`${API_BASE_URL}/timeslot`, {
            method: "POST",
            body: JSON.stringify(newData),
            ...buildDefaultHeaders(getState)
        });

        const result = (await response.json());
        if (response.ok) {
            createNotification('success', 'Успешно');
            await dispatch(getTimeSlotList(params));
            if (addMode) {
                const newId = (await response.json()).xp_key; 
                await dispatch(getTimeSlotItem(newId));
            } else {
                
            }
        } else 
        createNotification('error', result.error || 'Ошибка')
        }
    };

export const deleteTimeSlot = (id, params) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        const response = await fetch(`${API_BASE_URL}/timeslot/${id}`, {
            method: "DELETE",
            ...buildDefaultHeaders(getState)
        });
        const result = await response.json();

        if (response.ok) {
            createNotification('success', 'Успешно');
            await dispatch(getTimeSlotList(params));
        } else 
            createNotification('error', result.error);
        }
    };

export const getTimeSlotItem = (id) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(`${API_BASE_URL}/timeslot/${id} `, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const result = (await response.json());
      dispatch({ 
        type: SET_TIME_SLOT_BY_ID, 
        payload: {...result, 
                     starttime: minToTime(result.starttime),
                     stoptime: minToTime(result.stoptime),
                } });
    }
  }
};